const targetChannelTypes = {
    EMAIL: "EMAIL",
    FB_MESSENGER: "FB_MESSENGER",
};

export default targetChannelTypes;
